import { axiosAuth, axiosNoAuth } from '../../config/axiosInstances';
import { Api_url } from '../../common/api_url';
import { API_XANO_BASE_URL } from '../../config/api_config';

export function getAllSkills(course_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosNoAuth.get(
        API_XANO_BASE_URL +
        Api_url.GetSkillsForCourse +
        `?course_slug=${course_slug}`
      );
      successCallback && successCallback(response.data);
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e);
    }
  };
}

export function getAllSkillsForDropDown(course_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosNoAuth.get(
        API_XANO_BASE_URL +
        Api_url.GetSkillsForCourseDropDown +
        `?course_slug=${course_slug}`
      );
      successCallback && successCallback(response.data);
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  };
}

export function getSkillsForMegaMenu(course_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosNoAuth.get(
        API_XANO_BASE_URL +
        Api_url.GetSkillsForMegaMenu +
        `?course_slug=${course_slug}`
      );

      successCallback && successCallback(response.data);
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  };
}

export function getAllMSkillsForDropDown(skill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosNoAuth.get(
        API_XANO_BASE_URL +
        Api_url.GetMSkillsForCourseDropDown +
        `?skill_slug=${skill_slug}`
      );

      successCallback && successCallback(response.data);
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  };
}

export function getSkill(userId, skill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetSkill,
        {
          params: {
            user_id: userId,
            skill_slug: skill_slug,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  };
}


export function getRelatedSkills(skill_id , successCallback , errorCallback){
  return async function(dispatch){
    try{
      let response = await axiosNoAuth.get(
       'https://xgfy-czuw-092q.m2.xano.io/api:HYL0rVog/skill/related_skills',{
        params : {
          skill_id
        }
       }
      );

      successCallback && successCallback(response.data);
    }
    catch(e){
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  }
}

export function getAllMSkills(course_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosNoAuth.get(
        API_XANO_BASE_URL +
        Api_url.GetMSkillsForCourse +
        `?course_slug=${course_slug}`
      );

      successCallback && successCallback(response.data);
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e);
    }
  };
}

export function getMSkills(skill_slug, user_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetMSkillsForskill, {
        params: {
          skill_slug: skill_slug,
          user_id
        }
      }
      );

      successCallback && successCallback(response.data);
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  };
}

export function getUserProgress(
  userId,
  skill_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetUserProgress,
        {
          params: {
            user_id: userId,
            skill_slug: skill_slug,
          },
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function addToWishlist(
  user_id,
  skill_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        API_XANO_BASE_URL + Api_url.AddToWishlist,
        {
          user_id,
          skill_slug,
        },
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function addedToWishlist(
  user_id,
  skill_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.AddedToWishlist,
        {
          params: {
            user_id,
            skill_slug,
          },
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function deleteFromWishlist(
  user_id,
  skill_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.delete(
        API_XANO_BASE_URL + Api_url.DeleteFromWishlist,
        {
          params: {
            user_id,
            skill_slug,
          },
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function addMSkillToWishlist(
  user_id,
  mskill_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        API_XANO_BASE_URL + Api_url.AddMSkillToWishlist,
        {

          user_id,
          mskill_slug,
        },
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function deleteMSkillFromWishlist(
  user_id,
  mskill_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.delete(
        API_XANO_BASE_URL + Api_url.DeleteMSkillFromWishlist,
        {
          params: {
            user_id,
            mskill_slug,
          },
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function addReview(
  user_id,
  skill_slug,
  feedback,
  rating,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        API_XANO_BASE_URL + Api_url.AddReview,
        {
          user_id,
          skill_slug,
          feedback,
          rating
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getWishlist(
  user_id,
  course_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetWishlist,
        {
          params: {
            user_id,
            course_slug,
          },
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getMSkillWishlist(
  user_id,
  course_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetMSkillWishlist,
        {
          params: {
            user_id,
            course_slug,
          },
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getAllMSkillWishlist(
  user_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetAllMSkillWishlist,
        {
          params: {
            user_id,
          },
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getEnrolledMSkills(
  user_id,
  skill_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetEnrolledMSkills,
        {
          params: {
            user_id,
            skill_slug,
          },
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getAllEnrolledMSkills(
  user_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.ALLEnrolledMSkills,
        { params: { user_id } }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function enrollMSkill(
  user_id,
  skill_slug,
  mskill_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        API_XANO_BASE_URL + Api_url.EnrollMSkill,
        {
          user_id,
          skill_slug,
          mskill_slug,
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getCourseDetails(successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetCourseDetails
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  }
}

export function getMostViewedSkills(successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetMostViewedSkills
      );
      return successCallback && successCallback(response.data);
    } catch (err) {
      return errorCallback && errorCallback(err);
    }
  };
}

export function getMostViewedMicroSkills(successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetMostViewedMicroSkills
      );
      return successCallback && successCallback(response.data);
    } catch (err) {
      return errorCallback && errorCallback(err);
    }
  };
}

export function getOurTopPic(successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetOurTopPic
      );
      return successCallback && successCallback(response.data);
    } catch (err) {
      return errorCallback && errorCallback(err);
    }
  };
}

export function getFeaturedSkills(successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetFeaturedSkills
      );
      return successCallback && successCallback(response.data);
    } catch (err) {
      return errorCallback && errorCallback(err);
    }
  };
}

export function friendsLearningSkill(user_id, skill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetFriendsLearningSkill, {
        params: {
          user_id,
          skill_slug
        }
      })

      successCallback && successCallback(response.data)

    } catch (err) {
      console.log(err)
      errorCallback && errorCallback(err)
    }
  }
}

export function otherfriendsLearningSkill(
  user_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        API_XANO_BASE_URL + Api_url.OtherFriendsLearningSkill,
        {
          params: {
            user_id,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function perksSection( skill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.PerksSection,
        {
          params: {
            skill_slug,
          },
        }
      );

      successCallback && successCallback(response.data)

    } catch (err) {
      console.log(err)
      errorCallback && errorCallback(err)
    }
  }
}

export function getMetaTags( skill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetMetaTags,
        {
          params: {
            skill_slug,
          },
        }
      );

      successCallback && successCallback(response.data)

    } catch (err) {
      console.log(err)
      errorCallback && errorCallback(err)
    }
  }
}
export function getCourseMetaTags(course_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetCourseMetaTags,
        {
          params: {
            course_slug,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}
export function getReviews(skill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetReviews,
        {
          params: {
            skill_slug,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}